import { render, staticRenderFns } from "./depoDetay.vue?vue&type=template&id=578da90e&scoped=true&"
import script from "./depoDetay.vue?vue&type=script&lang=js&"
export * from "./depoDetay.vue?vue&type=script&lang=js&"
import style0 from "./depoDetay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./depoDetay.vue?vue&type=style&index=1&lang=css&"
import style2 from "./depoDetay.vue?vue&type=style&index=2&id=578da90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578da90e",
  null
  
)

export default component.exports